import { GtmEvent } from './types'

export function addGtmEvent(event: GtmEvent) {
  const dataLayer = (window as any).dataLayer
  if (!dataLayer) return
  dataLayer.push(event)
}
